import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDuration'
})
export class FormatDurationPipe implements PipeTransform {
    transform(totalMinutes: number | undefined | null): string {
        if (totalMinutes === undefined || totalMinutes === null) return '';

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        let result = "";
        if (hours > 0) result += `${hours} hour${hours > 1 ? 's' : ''}`;
        if (minutes > 0) {
            if (result) result += " ";
            result += `${minutes} min`;
        }

        return result || "0 min";
    }
}
